export default{
  sellingPoints: state => state.sellingPoints,
  sellingPoint: state => state.sellingPoint,
  studio: state => state.studio,
  onlineShops: state => state.onlineShops,
}